export default __webpack_public_path__ + "static/media/passportimage.910a79a3.jpg";